import { useSelector } from 'react-redux';
import { hasUserPermissions } from '../../helpers/utils/permissoes';
import { PERMISSAO_EDITAR_CLIENTE } from './usePodeConsultarOuEditarCliente';

/**
 * Gate do botão "Alterar" da aba Cliente (AW2-1136 Etapa 4) — SÓ a
 * permissão 504 (Editar), diferente de "Consultar Cliente" (501 OU 504) —
 * AC4: usuário só com Consultar não deve conseguir habilitar "Alterar".
 * Botão novo, não existe em `DadosCliente.jsx` real ainda — construído por
 * analogia direta ao gate de "Consultar Cliente" real.
 *
 * Mesmo padrão reativo de `usePodeConsultarOuEditarCliente.js` — gate
 * apenas cosmético, autorização real na rota de destino (`/cliente/:id/editar`,
 * já protegida por role 504 em `RoutesCliente.jsx`) e no backend.
 */
export default function usePodeEditarCliente() {
  useSelector(state => state.authentication.userInformation.permissoes);
  return hasUserPermissions(PERMISSAO_EDITAR_CLIENTE);
}
